export function getFuseResults(fuseResults) {
    if (!fuseResults) {
        return [];
    }
    return fuseResults.map((result) => result.item);
}
